export const SIGN_IN_USER = "SIGN_IN_USER";
export const SIGN_OUT_USER = "SIGN_OUT_USER";
export const LISTEN_TO_CURRENT_USER = "LISTEN_TO_CURRENT_USER";
